module.exports = __webpack_public_path__ + "static/img/wx_scan.ea7e447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/wx_scan.png
// module id = GlBm
// module chunks = 1